import { Component, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { Client } from "src/app/services/API/client"
import { LocaleConverterService } from "src/app/common/helpers/locale-converter.service"
import { SetTitleService } from "src/app/services/set-title.service";


interface MessageListItem {
  identification: number
  profileId: number
  type: string
  subject: string
  bankingUser: string
  sentTime: string
}

const INBOX = "Inbox"
const OUTBOX = "Outbox"
const LIMIT = 10

@Component({
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.css"]
})

export class MessageComponent implements OnInit {
  loadingInbox: boolean = false
  inboxes: MessageListItem[] = []
  inboxPage: number = 1
  inboxTotalRecords: number = 0
  loadingOutbox: boolean = false
  outboxes: MessageListItem[] = []
  outboxPage: number = 1
  outboxTotalRecords: number = 0

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private api: Client,
    private converter: LocaleConverterService,
    private router: Router,
    private settitleservice : SetTitleService
  ) {
  }

  ngOnInit() {
    this.getData();
    this.settitleservice.sendTitle("Message");
  }

  async getData() {
    await Promise.all([this.getMessages(INBOX), this.getMessages(OUTBOX)])
  }

  async getMessages(type: string, isRefresh: boolean = false) {
    if (!this.session.isLoggedIn()) return
    const isInbox = type === INBOX
    isInbox 
      ? (this.loadingInbox = true)
      : (this.loadingOutbox = true)

    const page = isInbox ? this.inboxPage : this.outboxPage

    try {
      const res: any = await this.api.get("api/message/getMessagesLazyLoad", { page: isRefresh ? 1 : page, LIMIT, type })
      const newData = res.data || []
      if (isInbox) {
        this.inboxes = isRefresh ? newData : this.inboxes.concat(newData)
        this.inboxTotalRecords = res.totalRecords || 0
        this.inboxPage = isRefresh ? 1 : page
      } else {
        this.outboxes = isRefresh ? newData : this.outboxes.concat(newData)
        this.outboxTotalRecords = res.totalRecords || 0
        this.outboxPage = isRefresh ? 1 : page
      }
    } catch(err) {
      this.toastr.error(err.message)
    }

    isInbox 
      ? (this.loadingInbox = false)
      : (this.loadingOutbox = false)
  }

  async loadMore(type: string) {
    const isInbox = type === INBOX
    if (isInbox) {
      if (this.loadingInbox || this.inboxes.length >= this.inboxTotalRecords) return
      this.inboxPage = this.inboxPage + 1
      this.getMessages(INBOX)
      return
    }

    if (this.loadingOutbox || this.outboxes.length >= this.outboxTotalRecords) return
    this.outboxPage = this.outboxPage + 1
    this.getMessages(OUTBOX)
  }

  goToCreatePage() {
    this.router.navigateByUrl("/create-message")
  }

  goToMessageDetail(id: any) {
    this.router.navigateByUrl(`/messages/${id}`)
  }
}